export enum DatalistType {
  Tests = 'Tests',
  About = 'About',
  EventClearence = 'EventClearence',
  Business = 'Business',
  Insurance = 'Insurance',
}
